export const FieldInputSizes = {
  xs: 'xs',
  sm: 'sm',
  md: 'md',
  lg: 'lg',
} as const

export type FieldInputType = 'text' | 'number' | 'date' | 'email' | 'url' | 'datetime-local' | 'hidden' | 'password' | 'search' | 'tel' | 'time'

export type DTSelectModelValue = string | number | string[] | number[] | null

export interface DTSelectOption {
  text: string
  value: string | number | null | undefined
}
